import * as React from 'react';
import * as styles from './ProjectsList.css';

export const ProjectsList: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
